<template>
  <div>
    <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">Carregando...</p>
    </div>
    <div class="main-content" v-else>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Categoria de Produto</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-8">
                    <label for="Name">
                      <span class="required">*</span> Nome da Categoria:
                    </label>
                    <input
                      autocomplete="new-password"
                      type="text"
                      id="Name"
                      class="form-control"
                      v-model="productCategory.name"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Status">
                      <span class="required">*</span> Status:
                    </label>
                    <select v-model="productCategory.status" class="form-control">
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </div>
                </div>
                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link to="/product_categories" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "productCategoryAdd",
  data() {
    return {
      pageLoading: true,
      productCategory: {
        name: "",
        status: "",
      },
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "product_categories";

      if (self.productCategory.id) {
        api += "/" + self.productCategory.id;
        self.productCategory._method = "PUT";
      }

      axios
        .post(api, self.productCategory)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/product_categories");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getProductCategory: function (id) {
      const self = this;
      const api = self.$store.state.api + "product_categories/" + id;

      return axios
        .get(api)
        .then((response) => {
          self.productCategory = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  async mounted() {
    const self = this;
    let id = self.$route.params.id;

    self.pageLoading = true;

    try {
      if (id) {
        await self.getProductCategory(id);
      }
    } catch (e) {
      console.error(e);
    } finally {
      self.pageLoading = false;
    }
  },
};
</script>
